export enum ProgressStatusEnum {
  Failed = 'Failed',
  Ongoing = 'Ongoing',
  Aborted = 'Aborted',
  Finished = 'Finished',
}
